import React from "react";
import MotionTile from "./motionTile";
import IconAward from "../../../images/icon-award-white.svg";
import IconQuotationMarks from "../../../images/icon-quotation-marks.svg";

function ContentTile({ tile, delay, entryAnimation }) {
  const title = tile?.projects_grid_card_title?.text;
  const subText = tile?.projects_grid_card_subtext?.text;
  const image = tile?.projects_grid_card_image;
  if (tile?.projects_grid_card_type === "Quote") {
    return (
      <MotionTile
        className="quote-card"
        delay={delay}
        entryAnimation={entryAnimation}
      >
        <div className="projects-grid__content">
          <div className="quote-card__logo">
            {
              image?.url ? (
                <div className="quote-card__img"><img src={image?.url} alt={image?.alt || 'Image'} /></div>
              ) : (
                <span>
                  <IconQuotationMarks />
                </span>
              )
            }
          </div>
          <p className="quote-card__title">
            {title}
          </p>
          <div className="quote-card__subtext">
            <p> {subText} </p>
          </div>
        </div>
      </MotionTile>
    );
  } else if (tile?.projects_grid_card_type === "Award") {
    return (
      <MotionTile
        className="award-card"
        delay={delay}
        entryAnimation={entryAnimation}
      >
        <div className="projects-grid__content">
          <div className="award-card__logo">
            {
              image?.url ? (
                <div className="award-card__img"><img  src={image?.url} alt={image?.alt || 'Image'} /></div>
              ) : (
                <IconAward />
              )
            }
          </div>
          <p className="h9 award-card__title">{title}</p>
          <div className="quote-card__subtext">
            <p className="h9"> {subText} </p>
          </div>
        </div>
      </MotionTile>
    );
  } else if (tile?.projects_grid_card_type === "Stat") {
    return (
      <MotionTile
        className="stat-card"
        delay={delay}
        entryAnimation={entryAnimation}
      >
        <div className="projects-grid__content">
          {
            image?.url &&
            <div className="stat-card__logo">
              <img src={image?.url} alt={image?.alt || 'Image'} />
            </div>
          }
          <p className="stat-card__title">{title}</p>
          <p className="stat-card__subtext">{subText}</p>
        </div>
      </MotionTile>
    );
  } else {
    return null;
  }
}

export default ContentTile;
